import React from "react";
import moment from 'moment';
import { NavLink, useNavigate } from "react-router-dom";

const BoxItem = ({
  imgSrc,
  link,
  altTitle,
  date,
  contentTitle,
  boxPara,
  customClass = "col-md-4",
  levelImg,
  levelTitle,
  levelContent,
  levelShow = false }) => {

  const navigator = useNavigate();

  return (
    <>
      <div className={`${customClass} boxItemList`} onClick={() => navigator(link)}>
        <div className="boxitem">
          <img src={imgSrc} alt={altTitle} />
          <div className="p-3">
            <p className="date"> {date && date}  </p>
            <h4>{contentTitle}</h4>
            <div dangerouslySetInnerHTML={{ __html: boxPara }}></div>
            {levelShow && <div className="level">
              <div className="circle"
                style={{
                  backgroundColor: levelContent === 'Easy' ? '#E5EDFF'
                    : levelContent === 'Medium' ? '#C5F8DA'
                      : levelContent === 'Difficult' ? '#F8C5C6'
                        : levelContent === 'Moderate' ? '#E0C5F8'
                          : "#E5EDFF"
                }}> <img alt="" title="" src={levelImg} />  </div>
              <div className="level_content">
                <h5> {levelTitle} </h5>
                <h6> {levelContent} </h6>
              </div>
            </div>}
          </div>
        </div>
      </div>
    </>
  );
};

export default BoxItem;
